selectorsRead = {
  textMore: '#read-more',
  textLess: '#read-less',
  mainContent: '#main-content',
  textToggle: '.read-more__toggle',
  wrapper: '.read-more__wrapper',

  textActive: 'read-more__text--active',
  textToggleMore: 'read-more__toggle--more',
  collectionBanner: 'collection-banner__read-more'
}

const textToggle = document.querySelectorAll(selectorsRead.textToggle);
const textMore = document.querySelector(selectorsRead.textMore);
const textLess = document.querySelector(selectorsRead.textLess);
const mainWrapper = document.querySelector(selectorsRead.mainContent);

function toggleText(event) {
  let closestWrapper = event.currentTarget.closest(selectorsRead.wrapper);

  let textLess = closestWrapper.querySelector(selectorsRead.textLess);
  let textMore = closestWrapper.querySelector(selectorsRead.textMore);

  textMore.classList.toggle(selectorsRead.textActive);
  textLess.classList.toggle(selectorsRead.textActive);

  if (!event.currentTarget.classList.contains(selectorsRead.textToggleMore) && event.currentTarget.classList.contains(selectorsRead.collectionBanner)) {
    mainWrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  event.currentTarget.classList.toggle(selectorsRead.textToggleMore);
}

textToggle.forEach(trigger => {
  trigger.addEventListener('click', toggleText);
});